import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../../../utils/API/requestMiddleware";

const EmailTemplateManagementApi = createApi({
    reducerPath: 'EmailTemplateManagementApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getAllProjectTypeDropdown: builder.query({
            query: (id) => ({
                url: `/FieldManagement/GetAllProjectTypeDropdown`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getEmailTemplateList: builder.mutation({
            query: (details) => ({
                url: '/FieldManagement/GetEmailTemplateList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditEmailTemplate: builder.mutation({
            query: (details) => ({
                url: '/FieldManagement/AddEditEmailTemplate',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteEmailTemplate: builder.mutation({
            query: (details) => ({
                url: '/FieldManagement/DeleteEmailTemplate',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getEmailTemplateById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/FieldManagement/GetEmailTemplateById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})
export const {
    useLazyGetAllProjectTypeDropdownQuery,
    useGetEmailTemplateListMutation,
    useAddEditEmailTemplateMutation,
    useDeleteEmailTemplateMutation,
    useLazyGetEmailTemplateByIdQuery
} = EmailTemplateManagementApi;

export default EmailTemplateManagementApi;